// Diccionario simple de categorías
export const categorias: Record<string, string[]> = {
    Verdura: [
        "lechuga", "tomate", "zanahoria", "pepino",
        "cebolla", "patata", "calabacin", "puerro"
    ],
    Fruta: [
        "manzana", "plátano", "pera", "peras",
        "fresa", "melón", "naranja", "sandia", "sandía"
    ],
    Carne: [
        "pollo", "ternera", "cerdo", "jamón",
        "chuleta", "carne", "bacon", "lomo", "salchichas"
    ],
    Pescado: [
        "salmón", "atún", "merluza", "gamba",
        "mejillón", "pescado"
    ],
    Lácteos: [
        "leche", "yogur", "yogures",
        "queso", "mantequilla", "huevos"
    ],
    Panadería: [
        "pan", "croissant", "bocadillo",
        "magdalena", "bollería", "panecillos"
    ],
    FrutosSecos: [
        "nueces", "almendras", "pistachos", "avellanas", "pipas"
    ],
    Desayuno: [
        "granola", "galletas", "cereales",
        "nutella", "azúcar"
    ],
    Limpieza: [
        "lejía", "detergente", "suavizante", "toallitas",
        "bayeta", "lavavajillas", "servilletas",
        "papel de cocina", "liquido azul", "líquido azul"
    ],
    Bebidas: [
        "agua", "vino", "cerveza", "cervezas",
        "refresco", "zumo", "coca cola"
    ],
    Salsas: [
        "aceite", "ketchup", "mayonesa", "soja", "soia"
    ],
    Conservas: [
        "atún", "sardinas", "maíz",
        "tomate frito", "legumbres", "olivas", "sal"
    ],
    Congelados: [
        "arroz congelado"
    ],
    Higiene: [
        "preservativos", "globos",
        "cepillo de dientes", "champú", "gel",
        "papel culo", "papel higiénico", "desmaquillante",
        "bastoncillos"
    ],
    PastaArroz: [
        "macarrones"
    ],
    Otros: [
        "bolsas zip", "chicles", "chicles trabajo",
        "papel albal", "papel horno"
    ]
};
